/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateDonationCampaignDto = {
  /**
   * 단체 ID
   */
  organizationId?: string;
  /**
   * 캠페인 제목
   */
  title?: string;
  /**
   * 설명
   */
  description?: string;
  /**
   * 썸네일 URL
   */
  thumbnailUrl?: string;
  /**
   * 상세 이미지 URL
   */
  detailImageUrl?: string;
  /**
   * 상세 이미지 URL 목록
   */
  detailImageUrls?: Array<string>;
  /**
   * 목표 금액
   */
  goalAmount?: number;
  /**
   * 시작일
   */
  startDate?: string;
  /**
   * 종료일
   */
  endDate?: string;
  /**
   * 상태
   */
  status?: UpdateDonationCampaignDto.status;
};
export namespace UpdateDonationCampaignDto {
  /**
   * 상태
   */
  export enum status {
    ACTIVE = "ACTIVE",
    HIDDEN = "HIDDEN",
  }
}
